(function () {
  'use strict';

  var header = document.querySelector('[data-site-header]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var navToggle = document.querySelector('[data-nav-toggle]');
  var root = document.documentElement;
  var scrolled = false;
  var menuOpen = false;

  function setHeaderHeight(scrolledState, menuOpenState) {
    var hidePromo = scrolledState || menuOpenState;
    var promoHeight = hidePromo ? '0px' : '2.5rem';
    root.style.setProperty('--promo-bar-height', promoHeight);
    root.style.setProperty('--header-height', hidePromo
      ? 'var(--header-bar-height)'
      : 'calc(var(--header-bar-height) + 2.5rem)');
  }

  if (header) {
    var onScroll = function () {
      var y = window.scrollY;
      if (!scrolled && y > 24) {
        scrolled = true;
        header.classList.add('is-scrolled');
        setHeaderHeight(true, menuOpen);
      } else if (scrolled && y < 8) {
        scrolled = false;
        header.classList.remove('is-scrolled');
        setHeaderHeight(false, menuOpen);
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function closeMenu() {
    if (!mobileMenu || !navToggle) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.hidden = true;
    mobileMenu.setAttribute('aria-hidden', 'true');
    navToggle.setAttribute('aria-expanded', 'false');
    navToggle.setAttribute('aria-label', 'Open menu');
    if (header) {
      header.classList.remove('is-menu-open');
      menuOpen = false;
      setHeaderHeight(header.classList.contains('is-scrolled'), false);
    }
    document.body.style.overflow = '';
  }

  function openMenu() {
    if (!mobileMenu || !navToggle) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.hidden = false;
    mobileMenu.setAttribute('aria-hidden', 'false');
    navToggle.setAttribute('aria-expanded', 'true');
    navToggle.setAttribute('aria-label', 'Close menu');
    if (header) {
      header.classList.add('is-menu-open');
      menuOpen = true;
      setHeaderHeight(header.classList.contains('is-scrolled'), true);
    }
    document.body.style.overflow = 'hidden';
  }

  if (navToggle && mobileMenu) {
    navToggle.addEventListener('click', function () {
      if (mobileMenu.classList.contains('is-open')) closeMenu();
      else openMenu();
    });

    mobileMenu.querySelectorAll('[data-close-menu]').forEach(function (el) {
      el.addEventListener('click', closeMenu);
    });
  }

  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form');
    if (!form) return;
    var select = form.querySelector('[data-variant-select]');
    if (!select) return;

    picker.querySelectorAll('[data-variant-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var optionIndex = btn.getAttribute('data-option-index');
        picker.querySelectorAll('[data-option-index="' + optionIndex + '"]').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        updateVariant(form, select);
      });
    });
  });

  function updateVariant(form, select) {
    var productJson = form.querySelector('[data-product-json]');
    if (!productJson) return;
    var product = JSON.parse(productJson.textContent);
    var selectedOptions = [];
    form.querySelectorAll('[data-variant-picker]').forEach(function (picker, i) {
      var selected = picker.querySelector('.is-selected');
      selectedOptions[i] = selected ? selected.getAttribute('data-value') : product.options[i];
      var label = form.querySelector('[data-option-label="' + i + '"]');
      if (label && selected) label.textContent = selected.getAttribute('data-value');
    });
    var variant = product.variants.find(function (v) {
      return v.options.every(function (opt, idx) { return opt === selectedOptions[idx]; });
    });
    if (!variant) return;
    select.value = variant.id;

    var section = form.closest('[data-product-section]') || form.closest('section');
    var priceEl = section && section.querySelector('[data-product-price]');
    var mobilePrice = section && section.querySelector('[data-mobile-price]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var mobileBtn = section && section.querySelector('[data-mobile-add]');

    var moneyFormat = window.Shopify && Shopify.formatMoney
      ? function (cents) { return Shopify.formatMoney(cents); }
      : function (cents) { return (cents / 100).toFixed(2); };

    if (priceEl) {
      var html = '<div class="price' + (variant.compare_at_price > variant.price ? ' price--on-sale price--large' : ' price--large') + '">';
      html += '<span class="price__current">' + moneyFormat(variant.price) + '</span>';
      if (variant.compare_at_price > variant.price) {
        html += '<s class="price__compare">' + moneyFormat(variant.compare_at_price) + '</s>';
        html += '<span class="price__savings">Save ' + moneyFormat(variant.compare_at_price - variant.price) + '</span>';
      }
      html += '</div>';
      priceEl.innerHTML = html;
    }

    if (mobilePrice) {
      mobilePrice.innerHTML = '<div class="price"><span class="price__current">' + moneyFormat(variant.price) + '</span></div>';
    }

    var available = variant.available;
    if (addBtn) {
      addBtn.disabled = !available;
      addBtn.textContent = available ? 'Add to bag' : 'Sold out';
    }
    if (mobileBtn) mobileBtn.disabled = !available;
  }

  document.querySelectorAll('[data-collection-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });

  document.querySelectorAll('[data-pdp-gallery]').forEach(function (gallery) {
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var counter = gallery.querySelector('[data-gallery-counter]');
    var stage = gallery.querySelector('.pdp-gallery__stage');
    var activeIndex = 0;

    function showSlide(index) {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
      });
      thumbs.forEach(function (thumb, i) {
        var active = i === activeIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (counter) {
        counter.textContent = String(activeIndex + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { showSlide(activeIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showSlide(activeIndex + 1); });
    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { showSlide(index); });
    });

    if (stage && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      stage.addEventListener('mouseenter', function () { stage.classList.add('is-zoomed'); });
      stage.addEventListener('mouseleave', function () { stage.classList.remove('is-zoomed'); });
    }
  });

  document.querySelectorAll('[data-shope-accordion]').forEach(function (accordion) {
    var triggers = accordion.querySelectorAll('[data-accordion-trigger]');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panel = trigger.parentElement.querySelector('[data-accordion-panel]');
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        triggers.forEach(function (other) {
          other.setAttribute('aria-expanded', 'false');
          var otherPanel = other.parentElement.querySelector('[data-accordion-panel]');
          if (otherPanel) otherPanel.classList.remove('is-open');
        });

        if (!isOpen && panel) {
          trigger.setAttribute('aria-expanded', 'true');
          panel.classList.add('is-open');
        }
      });
    });
  });

  function getVisibleSlides(width) {
    if (width >= 1280) return 5;
    if (width >= 1024) return 4;
    if (width >= 768) return 3;
    if (width >= 640) return 2;
    return 1;
  }

  document.querySelectorAll('[data-carousel-viewport]').forEach(function (viewport) {
    var section = viewport.closest('.social-proof');
    if (!section) return;

    var track = viewport.querySelector('[data-carousel-track]');
    var slides = track ? track.querySelectorAll('[data-carousel-slide]') : [];
    var prevBtn = section.querySelector('[data-carousel-prev]');
    var nextBtn = section.querySelector('[data-carousel-next]');
    var dotsWrap = section.querySelector('[data-carousel-dots]');
    if (!track || !slides.length) return;

    var gap = 16;
    var index = 0;
    var visible = 1;
    var slideWidth = 280;
    var maxIndex = 0;

    function renderDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      if (maxIndex <= 0) {
        dotsWrap.hidden = true;
        return;
      }
      dotsWrap.hidden = false;
      for (var i = 0; i <= maxIndex; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'social-proof__dot' + (i === index ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to testimonials page ' + (i + 1));
        if (i === index) dot.setAttribute('aria-current', 'true');
        dot.innerHTML = '<span></span>';
        dot.addEventListener('click', function (page) {
          return function () { goTo(page); };
        }(i));
        dotsWrap.appendChild(dot);
      }
    }

    function updateButtons() {
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= maxIndex;
    }

    function goTo(nextIndex) {
      index = Math.max(0, Math.min(nextIndex, maxIndex));
      track.style.transform = 'translateX(' + (-index * (slideWidth + gap)) + 'px)';
      updateButtons();
      renderDots();
    }

    function measure() {
      var width = viewport.clientWidth;
      visible = getVisibleSlides(width);
      slideWidth = (width - (visible - 1) * gap) / visible;
      maxIndex = Math.max(0, slides.length - visible);
      index = Math.min(index, maxIndex);

      slides.forEach(function (slide) {
        slide.style.width = slideWidth + 'px';
      });

      track.style.gap = gap + 'px';
      goTo(index);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });

    measure();
    if (typeof ResizeObserver !== 'undefined') {
      var observer = new ResizeObserver(measure);
      observer.observe(viewport);
    } else {
      window.addEventListener('resize', measure);
    }
  });

  document.querySelectorAll('[data-cart-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('[data-qty-input]');
    if (!input) return;
    var key = input.getAttribute('data-line-key');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');

    function setQty(nextQty) {
      var qty = Math.max(0, Math.min(99, nextQty));
      input.value = qty;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () {
        window.location.reload();
      });
    }

    if (minus) {
      minus.addEventListener('click', function () {
        setQty(parseInt(input.value, 10) - 1);
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        setQty(parseInt(input.value, 10) + 1);
      });
    }
  });
})();
